import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-tracking';

import { useUserInfoContext } from '@spotahome/marketplace-common/src/context/UserInfoContext';
import AlertButton from '@spotahome/marketplace-common/src/components/AlertButton';

import './AlertsCreationReminder.scss';

const ALERTS_CREATION_IMAGE =
  'https://df4usm6ck0nqa.cloudfront.net/images/no_results.svg';

const handleSaveMySearch = () => {
  Metrics.ga.sendEvent('Search', 'Alert few results CTA', 'click button');
};

const AlertsCreationReminder = ({ cityId, filters, hasZeroResults }) => {
  const { isUserLogged } = useUserInfoContext();

  return (
    <div className="alert-creation-reminder" data-test="alertCreationReminder">
      <img
        src={ALERTS_CREATION_IMAGE}
        alt={trans('search.alert.button.save-my-search')}
      />
      <div className="alert-creation-reminder__text">
        {hasZeroResults
          ? trans('search.alert.creation.reminder')
          : trans('search.alert.creation.reminder.with.results')}
      </div>
      <div className="alert-creation-reminder__cta">
        <AlertButton
          cityId={cityId}
          filters={filters}
          buttonProps={{
            color: 'interaction'
          }}
          isUserLogged={isUserLogged}
          onClick={handleSaveMySearch}
          dataTest="alert-creation-reminder"
        />
      </div>
    </div>
  );
};
AlertsCreationReminder.propTypes = {
  filters: PropTypes.shape({}),
  cityId: PropTypes.string.isRequired,
  hasZeroResults: PropTypes.bool
};

AlertsCreationReminder.defaultProps = {
  filters: {},
  hasZeroResults: false
};

export default AlertsCreationReminder;
